import * as React from 'react';
import type { TextButtonProps } from '../TextButton/types';
import type { ButtonProps } from '../Button/types';
import { TPAComponentProps } from '../../types';

export interface SectionNotificationProps extends TPAComponentProps {
  /* There are 4 different types: ‘default’, ‘error’, ‘alert’, and ‘wired’. The default value is ‘default’. */
  type?: string;
  children?: React.ReactNode;
  /* There are 2 different sizes: ‘regular’, ‘compact’. Each size defines the padding size. The default value is ‘regular’.*/
  size?: string;
  'aria-label'?: string;
}

export interface SectionNotificationDefaultProps {
  type: string;
  size: string;
}

export interface SectionNotificationIconProps {
  icon?: React.ReactNode;
  className?: string;
}

export interface SectionNotificationTextProps {
  className?: string;
  children?: React.ReactNode;
}

export enum SectionNotificationButtonType {
  default = 'default',
  text = 'text',
}

export type SectionNotificationButtonProps =
  | ButtonProps
  | TextButtonProps
  | {
      type?: 'default' | 'text' | SectionNotificationButtonType;
      children?: React.ReactNode;
    };

export enum SectionNotificationType {
  default = 'default',
  error = 'error',
  alert = 'alert',
  wired = 'wired',
  success = 'success',
}

export enum SectionNotificationSize {
  regular = 'regular',
  compact = 'compact',
}

export interface SectionNotificationContext {
  type: SectionNotificationProps['type'];
}

export enum SectionNotificationDataHooks {
  icon = 'icon',
  text = 'text',
  button = 'button',
}
